import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';
import './styles/App.css';

// Public components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import Services from './components/Services';
import About from './components/About';
import Booking from './components/Booking';
import Contact from './components/Contact';
import Blog from './components/Blog';
import EmailTest from './components/EmailTest';

// Admin components
import AdminLogin from './components/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import ServicesList from './components/admin/ServicesList';
import ServiceForm from './components/admin/ServiceForm';
import AdminBookings from './components/admin/AdminBookings';
import AdminSettings from './components/admin/AdminSettings';
import AdminHomeContent from './components/admin/AdminHomeContent';
import AdminBlog from './components/admin/AdminBlog';
import BlogEditor from './components/admin/BlogEditor';

function App() {
  return (
    <Router>
      <Routes>
        {/* Admin Routes (no Navbar/Footer) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="services" element={<ServicesList />} />
          <Route path="services/new" element={<ServiceForm />} />
          <Route path="services/edit/:id" element={<ServiceForm />} />
          <Route path="home-content" element={<AdminHomeContent />} />
          <Route path="bookings" element={<AdminBookings />} />
          <Route path="blog" element={<AdminBlog />} />
          <Route path="blog/new" element={<BlogEditor />} />
          <Route path="blog/edit/:id" element={<BlogEditor />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        {/* Public Routes (with Navbar/Footer) */}
        <Route path="/*" element={
          <div className="App">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/email-test" element={<EmailTest />} />
            </Routes>
            <Footer />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
